export const UPDATE_DATA = 'app/EditSessionPage/Phone/UPDATE';
export const UPDATE_VARIABLE = 'app/EditSessionPage/Phone/UPDATE_VARIABLE';
